import { SectionNode } from '../../'

export class SeparatorSectionNode extends SectionNode {}
